import { render, staticRenderFns } from "./DateIOSPicker.vue?vue&type=template&id=36910f7c&scoped=true"
import script from "./DateIOSPicker.vue?vue&type=script&lang=js"
export * from "./DateIOSPicker.vue?vue&type=script&lang=js"
import style0 from "./DateIOSPicker.vue?vue&type=style&index=0&id=36910f7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36910f7c",
  null
  
)

export default component.exports